
import { FeedbackMessage } from "@/types/feedback";
import { sendWebhook } from "./webhookUtils";

/**
 * Send a webhook notification when a new feedback message is created
 */
export const sendFeedbackWebhook = async (
  feedbackMessage: FeedbackMessage
): Promise<boolean> => {
  const webhookUrl = "https://luijtenvvz.app.n8n.cloud/webhook/6f1624f5-bcad-4a82-b930-c552e499fb87";
  
  try {
    const payload = {
      message_id: feedbackMessage.id,
      username: feedbackMessage.username,
      message: feedbackMessage.message,
      category: feedbackMessage.category_tag || "geen categorie",
      timestamp: new Date().toISOString(),
      parent_id: feedbackMessage.parent_id || null,
      is_reply: !!feedbackMessage.parent_id
    };
    
    const result = await sendWebhook({
      webhookUrl,
      payload,
      webhookType: 'feedback',
      entityId: feedbackMessage.id,
      entityType: 'feedback_message'
    });
    
    return result.success;
  } catch (error) {
    console.error("Unexpected error in feedback webhook service:", error);
    return false;
  }
};
